import { useState, useEffect } from 'react';
import { listLocations } from '../services/locations';
import { Location } from '../types/models';

export function useLocations() {
  const [locations, setLocations] = useState<Location[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    listLocations()
      .then(setLocations)
      .catch(err => setError((err as Error).message))
      .finally(() => setLoading(false));
  }, []);

  return { locations, loading, error };
}
